module.exports = __webpack_public_path__ + "static/media/wake-up.7a726a6d.gif";